import styled from 'styled-components'

const ContextualConversationsBlock = styled.div`
  border-bottom: 1px solid #EBEBEF;
  padding-bottom: 32px;
  margin-bottom: 32px;
`

export { ContextualConversationsBlock }
